import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class RemoveHoles extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.removeholes',
        group: 'Spatial Constructors',
        title: 'Remove Holes',
        description: `
      This component generates a new geo column with polygons without holes.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source polygons table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT ST_MAKEPOLYGON(ST_EXTERIORRING(${params.geo}))
                  AS ${params.geo}_noholes, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  SEDONA_ST_ASBINARY(SEDONA_ST_MAKEPOLYGON(SEDONA_ST_EXTERIORRING(SEDONA_ST_GEOMFROMWKB(${
                    params.geo
                  }))))
                    AS ${params.geo}_noholes, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle: {
        const geoColumn = params.geo as string
        const noHolesColumn = `${params.geo}_noholes`
        return dedent`SELECT
                  SDO_GEOM.SDO_BUFFER(
                    SDO_GEOM.SDO_BUFFER(t.${geoColumn}, -0.001, 0.005),
                    0.001, 0.005
                  ) AS ${noHolesColumn}, t.*
                FROM ${connection.quoteName(params.source as string)} t`
      }
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return columns.source
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.DatabricksRest, Provider.Oracle]
  }
}

export { RemoveHoles }
